import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import "../Styles/Feecategory.css";
import ApiConfig from "../api/ApiConfig";
import { simplePostCall } from "../api/ApiServices";
import ScaleLoader from "react-spinners/ScaleLoader";
import { toast, ToastContainer } from "react-toastify";
import { FaEdit, FaEye, FaTrashAlt, FaSearch } from "react-icons/fa";

export default function FeeCategoryTable() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]); // Original API data
  const [filteredData, setFilteredData] = useState([]); // Data shown in table

  // Filter States
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedType, setSelectedType] = useState("All");

  const handleNavigate = (path) => navigate(`/${path}`);

  useEffect(() => {
    loadDataStudentFee();
  }, []);

  // Sync filteredData whenever search, dropdown, or raw data changes
  useEffect(() => {
    let result = data;

    // Filter by Type (Fee, Discount, etc.)
    if (selectedType !== "All") {
      result = result.filter(
        (item) =>
          item.fee_category_type?.toLowerCase() === selectedType.toLowerCase(),
      );
    }

    // Filter by Search Term (Category Name)
    if (searchTerm) {
      result = result.filter((item) =>
        item.fee_category_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()),
      );
    }

    setFilteredData(result);
  }, [searchTerm, selectedType, data]);

  const loadDataStudentFee = async () => {
    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    const requestBody = {
      customer_id: Number(customer_id),
      api_key: api_key,
      category_name: "", // Fetching all and filtering client-side for speed
    };

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategorylist,
        JSON.stringify(requestBody),
      );

      if (response?.result) {
        setData(response.data);
        setFilteredData(response.data);
      } else {
        setData([]);
        setFilteredData([]);
      }
    } catch (error) {
      console.error("Error loading list:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedType("All");
  };

  const loadDataStudentFeeDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    setIsLoading(true);
    const customer_id = localStorage.getItem("customer_id");
    const api_key = localStorage.getItem("api_key");

    try {
      const response = await simplePostCall(
        ApiConfig.feeCategoryDELETE,
        JSON.stringify({
          customer_id: Number(customer_id),
          api_key: api_key,
          category_id: id,
        }),
      );

      if (response?.result) {
        toast.success("Deleted Successfully!");
        loadDataStudentFee(); // Refresh the list
      } else {
        toast.error(response?.message || "Delete failed");
      }
    } catch (error) {
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="category-container">
      <ToastContainer />
      {/* Header */}
      <div className="special-header panel-white-all">
        <h4 className="page-title">Fee Categories</h4>
        <Link to="/createfee" className="btn btn-primary">
          Create Fee Category
        </Link>
      </div>

      <div className="yc-list-body">
        {/* Filters */}
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <input
              type="text"
              className="form-control ff-search-input"
              placeholder="Search Category"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <select
            className="form-select"
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
          >
            <option value="All">All Types</option>
            <option value="Fee">Fee</option>
            <option value="Discount">Discount</option>
            <option value="Bonus">Bonus</option>
          </select>

          <button type="button" className="btn btn-primary" onClick={handleClear}>
            Clear
          </button>
        </div>

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-7">
            <div className="yc-list-cell">Sr No</div>
            <div className="yc-list-cell">Category Name</div>
            <div className="yc-list-cell">Category Type</div>
            <div className="yc-list-cell">Amount Type</div>
            <div className="yc-list-cell">Applicable To</div>
            <div className="yc-list-cell">Status</div>
            <div className="yc-list-cell">Action</div>
          </div>
        </div>

        {/* Rows */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : filteredData.length > 0 ? (
          <div className="yc-list-row-list">
            {filteredData.map((row, index) => (
              <div key={row.fee_category_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-7">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{row.fee_category_name}</div>
                  <div className="yc-list-cell">{row.fee_category_type}</div>
                  <div className="yc-list-cell">{row.fee_category_amount_type}</div>
                  <div className="yc-list-cell">{row.fee_category_applicable_to}</div>
                  <div className="yc-list-cell">{row.fee_category_status}</div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      className="yc-action-icon"
                      title="View"
                      onClick={() => handleNavigate(`Registration/${row.fee_category_id}`)}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="yc-action-icon"
                      title="Edit"
                      onClick={() => handleNavigate(`createfee/${row.fee_category_id}`)}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="yc-action-icon yc-action-icon--danger"
                      title="Delete"
                      onClick={() => loadDataStudentFeeDelete(row.fee_category_id)}
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No Categories Found</div>
        )}
      </div>
    </div>
  );
}
